import { Box, Typography } from "@mui/material"
import * as Styled from './EventMetricsCard.styles';

type EventMetricsCardProps = {
  value: string;
  label: string;
}

const EventMetricsCard = (props: EventMetricsCardProps) => {
  return (
    <>
      <Styled.CardContainer>
        <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column" ,rowGap: "8px", height: "100%" }}>
          <Typography sx={{ display: "flex", fontWeight: "bold", fontSize: "40px", flexGrow: "1" }}>{ props.value }</Typography>
          <Typography variant="modalBody" sx={{ display: "flex", fontWeight: "bold", whiteSpace: "nowrap", flexGrow: "0" }}>{ props.label }</Typography>
        </Box>
      </Styled.CardContainer>
    </>
  )
}

export default EventMetricsCard;